import React, {useCallback, useEffect, useState} from "react";
import {header} from "../../Components/Url/ApiUrl";
import {Logout} from "../../Components/Actions/Actions";
import swal from "sweetalert";
import axios from "axios";
import AddArea from "./AddArea";
import ShowFile from "../../Components/ShowFile/ShowFile";
import {useTranslation} from "react-i18next";

const OperationArea = ({regions, user}) => {
    const {t} = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddModal, setShowAddModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [showFile, setShowFile] = useState(false);
    const handleViewFile = async (filename) => {
        try {
            const response = await fetch(process.env.REACT_APP_API_ENDPOINT+'/files/employee/'+filename, {
                method: "GET",
                headers: header
            });

            if (!response.ok) {
                alert(`${t('translation:cannot_upload_file')}. ${t('translation:token_expired')}`);
                window.location.reload();
                return;
            }

            const blob = await response.blob();

            // MIME tipini tekshirib, faqat PDF bo‘lsa ochamiz
            if (blob.type !== "application/pdf") {
                alert(t('translation:pdf_only'));
                return;
            }
               const fileURL = URL.createObjectURL(blob);
            setPdfUrl(fileURL);
            setShowFile(true);
            // window.open(fileURL, "_blank");
        } catch (error) {
            alert(`${t('error')}: ` + error.message);
        }
    };

    const handleFetch = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(process.env.REACT_APP_API_ENDPOINT+'/company/operationarea', {
                method: "GET",
                headers: header,
            });
            if (response.status === 401) {
                Logout();
                return;
            }
            if (!response.ok) {
                throw new Error(t('translation:no_data_found'));
            }
            const companyData = await response.json();
            setData(companyData);
        } catch (error) {
            console.error('Company fetch xatosi:', error);
            swal(t('error'), error.message || t('translation:unknown_error'), "error");
        } finally {
            setLoading(false);
        }
    }, [t]);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    const deleteRegion = async (e, id, regName) => {
        e.preventDefault();
        if (window.confirm(t('translation:delete_region_confirm', { region: regName }))) {
            await axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/company/operationarea/${id}`,
                {
                    headers:header,
                }
            ).then(res=>{
                if(res.data?.success === true){
                    swal(t('translation:success'), res.data?.message, 'success')
                }
                if(res.data?.success === false){
                    swal(t('translation:error'), res.data?.message, 'error')
                }
                handleFetch()
            })
                .catch(err=>{
                    if (err.response?.status === 401) {
                        Logout();
                    }

                })
        }
    }

    const toggleAddMode = () => {
        setShowAddModal(true)
    }
    const handleCancel = () => {
        setShowAddModal(false);
    }
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{height: '200px'}}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('loading')}</span>
                </div>
            </div>
        );
    }
    return (
        <div className="operation-area-index">
            <div className="d-flex align-items-center">
                <div className="d-flex pb-3">
                    <h3 className="m-0 me-2">{t('translation:operation-areas')}</h3>
                    {Boolean(user.can_update) && (
                        <button
                            className="btn btn-success"
                            onClick={toggleAddMode}
                        >
                            {t('add_area')}
                        </button>
                    )}
                </div>
                {
                    user.can_update ?
                        <AddArea
                            show={showAddModal}
                            handleClose={handleCancel}
                            regions={regions}
                            onSuccess={handleFetch}
                        />
                        : ''
                }
            </div>
            <hr/>
            {showFile && (
                <ShowFile
                    pdfUrl={pdfUrl}
                    setShowFile={setShowFile}
                />
            )}
            <br/>
            <div className="container-fluid">
                <table className="table table-bordered table-striped text-center align-middle">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>{t('area_name')}</th>
                        <th>{t('specalists_diplom')}</th>
                        <th>{t('specialists_cvs')}</th>
                        <th>{t('specialists_certificats')}</th>
                        <th>{t('area_been_added')}</th>
                        <th>{t('has_been_edited')}</th>
                        <th>{t('delete')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        data ?
                            data.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.regName}</td>
                                        <td>
                                            {item.diplom ? (
                                                <button className="btn btn-link p-0"
                                                        onClick={() => handleViewFile(item.diplom)}>
                                                    {t('diploma')} <i className="bi bi-file-pdf"></i>
                                                </button>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                        <td>
                                            {item.cv ? (
                                                <button className="btn btn-link p-0"
                                                        onClick={() => handleViewFile(item.cv)}>
                                                    {t('cv')} <i className="bi bi-file-pdf"></i>
                                                </button>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                        <td>
                                            {item.sertifikat ? (
                                                <button className="btn btn-link p-0"
                                                        onClick={() => handleViewFile(item.sertifikat)}>
                                                    {t('certificates')} <i className="bi bi-file-pdf"></i>
                                                </button>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                        <td>{item.created_at}</td>
                                        <td>{item.updated_at}</td>
                                        <td>
                                            {Boolean(user.can_update) && (
                                                <button className="btn btn-transparent btn-outline-danger btn-rounded p-0" style={{width:"32px", height:"32px"}}
                                                        onClick={(e)=>{deleteRegion(e, item.id, item.regName)}}
                                                >
                                                    <i className="bi bi-trash icon-1-3rem"
                                                       title="O'chirish"></i>
                                                </button>
                                            )}

                                        </td>
                                    </tr>
                                ))
                            :<tr>
                                <td colSpan="8"><p className="text-center"><i>{t('area_not_added')}</i></p></td>
                            </tr>

                    }

                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default OperationArea;